import {useTheme} from 'styled-components';

const InfoIcon = ({size = 24}) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${size} ${size}`}
      width={size}
      height={size}
      fill={theme.name === 'dark' ? theme.colors.text.base : '#ffffff'}>
      <rect x="10.8" y="10" width="2.5" height="10" rx="1" />
      <circle cx="12" cy="6" r="1.8" />
    </svg>
  );
};

export default InfoIcon;
